'use strict';

/* global document:false, getComputedStyle:false */

function spotlight(options) {
  const object = this;
  const settings = Object.assign(
    {},
    {
      opacity: 0.5,
      speed: 400,
      color: '#333',
      easing: 'ease-out',
      exitEvent: 'click',
      onShow() {},
      onHide() {},
    },
    options
  );
  if (document.getElementById('spotlight') == null) {
    const spotlightElem = document.createElement('div');
    document.body.appendChild(spotlightElem);
    spotlightElem.id = 'spotlight';
    spotlightElem.style.position = 'fixed';
    spotlightElem.style.background = settings.color;
    spotlightElem.style.opacity = 0;
    spotlightElem.style.filter = 'alpha(opacity=0)';
    spotlightElem.style.top = 0;
    spotlightElem.style.bottom = 0;
    spotlightElem.style.left = 0;
    spotlightElem.style.right = 0;
    spotlightElem.style.zIndex = 9998;
    spotlightElem.style.transition = `opacity ${settings.speed}ms ${settings.easing}`;
    spotlightElem.style.opacity = settings.opacity;
    spotlightElem.style.filter = `alpha(opacity=${settings.opacity * 100})`;
    const currentPos = getComputedStyle(object)['position'];
    if (currentPos === 'static') {
      object.style.position = 'relative';
    }
    object.style.zIndex = 9999;
    spotlightElem.addEventListener(settings.exitEvent, () => {
      spotlightElem.style.opacity = 0;
      spotlightElem.style.filter = 'alpha(opacity=0)';
      setTimeout(() => {
        if (currentPos === 'static') object.style.position = 'static';
        //element.css('z-index', '1');
        object.style.zIndex = '1';
        spotlightElem.remove();
        // Trigger the onHide callback
        settings.onHide.call(object);
      }, settings.speed);
    });

    object.hideSpotlight = () => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent(settings.exitEvent, true, false);
      spotlightElem.dispatchEvent(event);
    };
  }
}

Object.defineProperty(Object.prototype, 'spotlight', {
  value: spotlight,
  writable: true,
  configurable: true,
  enumerable: false,
});
